// core
import React from "react";
import { ISellingPoint } from "../../../../../interfaces/ISellingPoint";
import cx from "classnames";
import SellingPoint from "../../../Components/SellingPoint/SellingPoint";
import styles from "./QuoteTableInsurerInfoContent.module.scss";

// interfaces
interface IQuoteTableInsurerContentProps {
    providerName: string;
    sellingPoints: ISellingPoint[];
}

// functions

// rendering
const QuoteTableInsurerContent: React.FC<IQuoteTableInsurerContentProps> = (props) => {
    const { providerName, sellingPoints } = props;

    return (
        <React.Fragment>
            <p className="text-font-size-s text-bold">{providerName} says</p>

            <ul className={cx(styles["quote-card-list"], "text-font-size-m")}>
                {sellingPoints.map((s) => (
                    <li key={s.id} className={styles["quote-card-list__paragraph"]}>
                        <SellingPoint sellingPoint={s} />
                    </li>
                ))}
            </ul>
        </React.Fragment>
    );
};

export default React.memo(QuoteTableInsurerContent);
